import React, { useCallback, useState } from "react";
import { map } from "ramda";

import List from "@mui/material/List";
import ApplicationAccountListItem from "./ApplicationAccountListItem";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "white",
  },
}));

const ApplicationAccountList = ({
  accounts,
  onActiveToggle,
  onEdit,
  onShowKeys,
}) => {
  const [currentAccount, setCurrentAccount] = useState({});
  const classes = useStyles();

  const handleRowSelected = useCallback(account => {
    setCurrentAccount(account);
  }, []);

  return (
    <List classes={{ root: classes.root }}>
      {map(account => {
        const selected =
          account.applicationId === currentAccount.applicationId ||
          account.applicationName === currentAccount.applicationName;
        return (
          <ApplicationAccountListItem
            key={account.applicationId}
            account={account}
            selected={selected}
            onEditClick={onEdit}
            onDeactivateClick={onActiveToggle}
            onActivateClick={onActiveToggle}
            onKeysClick={onShowKeys}
            onSelect={handleRowSelected}
          />
        );
      }, accounts)}
    </List>
  );
};

export default ApplicationAccountList;
